@if (isAuthenticated$ | async) {
  <rdx-home-authenticated />
}
